import axios from 'axios';

export default function createAxiosInstance() {
  return axios.create();
}
